import React from "react";

function ViewCoursesProduct() {
  return <div>ViewCoursesProduct</div>;
}

export default ViewCoursesProduct;
